import banner from "../../../courses/finanzas.webp";

const modulo7_pt = {
  courseId: "finanzas-personales",
  id: "modulo-7",
  title: "🧪 MÓDULO 7: Avaliação Final",
  estimatedDuration: "30–45 minutos",
  format: "Prova final on-line + reflexão opcional",
  bannerUrl: banner,
  sections: [
    {
      id: "objetivos",
      navLabel: "Objetivos",
      title: "🎯 Objetivos do módulo",
      content: [
        "Verificar se você compreende os conceitos-chave do curso.",
        "Confirmar que é capaz de aplicar o que aprendeu no seu dia a dia.",
        "Dar o passo final para obter o seu Certificado Profissional ZyVerse.",
      ],
    },
    {
      id: "incluye",
      navLabel: "Tópicos da Avaliação",
      title: "✅ O que inclui esta avaliação?",
      content: [
        "📌 Prova final",
        {
          type: "list",
          items: [
            "20 perguntas de múltipla escolha",
            "Baseadas nos 6 módulos anteriores",
            "Tópicos: orçamento, poupança, crédito, investimento, consumo e hábitos",
            "Duração estimada: 25–30 minutos",
            "Nota mínima para aprovação: 60 % de acertos",
          ],
        },
      ],
    },
    {
      id: "examen",
      navLabel: "Prova Final",
      title: "📝 PROVA FINAL",
      questions: [
        {
          id: "q1",
          question:
            "Qual é o primeiro passo para organizar suas finanças pessoais?",
          options: [
            { key: "a", text: "Investir em títulos públicos" },
            { key: "b", text: "Fazer um orçamento" },
            { key: "c", text: "Abrir um cartão de crédito" },
            { key: "d", text: "Comprar sempre à vista" },
          ],
          correct: "b",
        },
        {
          id: "q2",
          question: "Qual das afirmações sobre o orçamento é correta?",
          options: [
            { key: "a", text: "Só serve para quem ganha muito" },
            { key: "b", text: "Ajuda a planejar e controlar seus gastos" },
            { key: "c", text: "É o mesmo que poupar" },
            { key: "d", text: "Somente empresas usam" },
          ],
          correct: "b",
        },
        {
          id: "q3",
          question: "O que é o gasto formiga?",
          options: [
            { key: "a", text: "Grandes compras mensais" },
            { key: "b", text: "Pequenos gastos repetidos que se acumulam" },
            { key: "c", text: "Gastos emergenciais" },
            { key: "d", text: "Dinheiro emprestado" },
          ],
          correct: "b",
        },
        {
          id: "q4",
          question: "Qual é um exemplo de gasto fixo?",
          options: [
            { key: "a", text: "Cinema" },
            { key: "b", text: "Cafés" },
            { key: "c", text: "Aluguel" },
            { key: "d", text: "Lanches" },
          ],
          correct: "c",
        },
        {
          id: "q5",
          question: "O que representa a letra “M” em uma meta SMART?",
          options: [
            { key: "a", text: "Mensurável" },
            { key: "b", text: "Mínima" },
            { key: "c", text: "Mensal" },
            { key: "d", text: "Monetária" },
          ],
          correct: "a",
        },
        {
          id: "q6",
          question:
            "Qual é o percentual recomendado de uso do crédito disponível?",
          options: [
            { key: "a", text: "90 %" },
            { key: "b", text: "100 %" },
            { key: "c", text: "No máximo 30 %" },
            { key: "d", text: "10 %" },
          ],
          correct: "c",
        },
        {
          id: "q7",
          question: "O que é o bureau de crédito?",
          options: [
            { key: "a", text: "Uma empresa de cartões" },
            {
              key: "b",
              text: "Instituição que registra seu histórico financeiro",
            },
            { key: "c", text: "Um aplicativo de pagamentos" },
            { key: "d", text: "Um banco digital" },
          ],
          correct: "b",
        },
        {
          id: "q8",
          question: "Qual é um sinal de oferta de crédito perigosa?",
          options: [
            { key: "a", text: "Exige histórico de crédito" },
            { key: "b", text: "Promete dinheiro fácil sem requisitos" },
            { key: "c", text: "Tem taxa fixa" },
            { key: "d", text: "Pede comprovantes" },
          ],
          correct: "b",
        },
        {
          id: "q9",
          question: "O que é o juro composto?",
          options: [
            { key: "a", text: "Ganhar dinheiro indicando amigos" },
            { key: "b", text: "Gerar juros sobre juros anteriores" },
            { key: "c", text: "Um tipo de imposto" },
            { key: "d", text: "Pagamento por usar dinheiro físico" },
          ],
          correct: "b",
        },
        {
          id: "q10",
          question: "Qual destas opções é um investimento de baixo risco?",
          options: [
            { key: "a", text: "Criptomoedas" },
            { key: "b", text: "Títulos do governo (CETES)" },
            { key: "c", text: "Startups" },
            { key: "d", text: "Bolsa estrangeira" },
          ],
          correct: "b",
        },
        {
          id: "q11",
          question: "O que diz a Lei de Risco e Rentabilidade?",
          options: [
            { key: "a", text: "Maior ganho implica maior risco" },
            { key: "b", text: "Apenas ricos lucram" },
            { key: "c", text: "Investir é sempre seguro" },
            { key: "d", text: "O risco não afeta o retorno" },
          ],
          correct: "a",
        },
        {
          id: "q12",
          question:
            "Segundo a regra 110, se você tem 20 anos, quanto pode investir em ativos de risco?",
          options: [
            { key: "a", text: "80 %" },
            { key: "b", text: "60 %" },
            { key: "c", text: "90 %" },
            { key: "d", text: "30 %" },
          ],
          correct: "c",
        },
        {
          id: "q13",
          question: "O que significa consumir de forma responsável?",
          options: [
            { key: "a", text: "Comprar apenas produtos ecológicos" },
            { key: "b", text: "Gastar somente em dinheiro vivo" },
            {
              key: "c",
              text: "Comprar com consciência e alinhado às suas metas",
            },
            { key: "d", text: "Parar de consumir completamente" },
          ],
          correct: "c",
        },
        {
          id: "q14",
          question: "Qual técnica ajuda a reduzir compras por impulso?",
          options: [
            { key: "a", text: "Gasto livre" },
            { key: "b", text: "Lista de espera de 72 horas" },
            { key: "c", text: "Comprar com amigos" },
            { key: "d", text: "Usar vários cartões" },
          ],
          correct: "b",
        },
        {
          id: "q15",
          question: "O que representa o topo da pirâmide de Maslow?",
          options: [
            { key: "a", text: "Comida e transporte" },
            { key: "b", text: "Autorrealização" },
            { key: "c", text: "Segurança financeira" },
            { key: "d", text: "Família e amigos" },
          ],
          correct: "b",
        },
        {
          id: "q16",
          question:
            "O que você pode fazer para começar a poupar com propósito?",
          options: [
            { key: "a", text: "Guardar o que sobrar" },
            { key: "b", text: "Evitar gastar" },
            {
              key: "c",
              text: "Definir uma meta SMART e separar um valor fixo",
            },
            { key: "d", text: "Investir tudo em cripto" },
          ],
          correct: "c",
        },
        {
          id: "q17",
          question: "Para que serve o orçamento dos prazeres?",
          options: [
            { key: "a", text: "Eliminar gastos desnecessários" },
            { key: "b", text: "Impedir qualquer compra" },
            {
              key: "c",
              text: "Permitir aproveitar sem prejudicar suas finanças",
            },
            { key: "d", text: "Aumentar o limite do cartão" },
          ],
          correct: "c",
        },
        {
          id: "q18",
          question:
            "Qual ferramenta ajuda a observar seus hábitos financeiros?",
          options: [
            { key: "a", text: "Planilha de acompanhamento de hábitos" },
            { key: "b", text: "Aplicativo de clima" },
            { key: "c", text: "Cartório" },
            { key: "d", text: "Quadro de honra" },
          ],
          correct: "a",
        },
        {
          id: "q19",
          question: "O que inclui o Certificado Profissional ZyVerse?",
          options: [
            { key: "a", text: "Bônus em dinheiro" },
            { key: "b", text: "Cartão de débito" },
            { key: "c", text: "Nome, data, curso e código verificador" },
            { key: "d", text: "Seguro de vida" },
          ],
          correct: "c",
        },
        {
          id: "q20",
          question: "Qual frase resume melhor a filosofia do curso?",
          options: [
            { key: "a", text: "“Ganhe dinheiro rápido.”" },
            {
              key: "b",
              text: "“Decidir melhor é mais poderoso do que ganhar mais.”",
            },
            { key: "c", text: "“Compre sem medo.”" },
            { key: "d", text: "“Endividar-se é inevitável.”" },
          ],
          correct: "b",
        },
      ],
    },
    {
      id: "reflexion",
      navLabel: "Reflexão Final",
      title: "💡 Reflexão Final (opcional)",
      content: [
        "O que aprendi e como aplicarei?",
        "Embora não seja obrigatória, recomenda-se enviar uma reflexão escrita ou gravada para enriquecer seu processo de aprendizagem. Isso ajuda a integrar melhor os conceitos à sua vida pessoal.",
      ],
    },
    {
      id: "frase",
      navLabel: "Frase de Encerramento",
      title: "💬 Frase de Encerramento",
      content: [
        "“Este curso termina aqui, mas o seu caminho financeiro está apenas começando.”",
      ],
    },
  ],
};

export default modulo7_pt;
